"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabularContent = void 0;
const react_1 = __importDefault(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("../styles");
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const messages_1 = __importDefault(require("../../../common/util/constants/messages"));
exports.TabularContent = (0, intl_1.injectIntl)(({ provider, columns = [], labels: { nextPageLabel = 'Next', previousPageLabel = 'Previous', noRecordsLabel = 'No data available.', noRecordsOnSearchLabel = 'No data could be found that match your search criteria. Please remove your search term and try again.' } = {}, path = '', stateEventHandlers, intl }) => {
    const tableData = react_1.default.useMemo(() => {
        const data = (0, get_1.default)(provider, path);
        if (data != null && Array.isArray(data)) {
            return data;
        }
        return [];
    }, [path, provider]);
    const tableColumns = react_1.default.useMemo(() => columns.map((column) => {
        var _a, _b, _c;
        return {
            id: (_a = column.id) !== null && _a !== void 0 ? _a : '',
            accessor: (_b = column.id) !== null && _b !== void 0 ? _b : '',
            Header: (_c = column.label) !== null && _c !== void 0 ? _c : ''
        };
    }), [columns]);
    const paginatorProps = react_1.default.useMemo(() => ({
        pageSize: 10,
        currentPage: 0,
        nextPageRenderer: () => nextPageLabel,
        previousPageRenderer: () => previousPageLabel,
        totalCount: tableData === null || tableData === void 0 ? void 0 : tableData.length,
        showOutOf: true
    }), [tableData.length, nextPageLabel, previousPageLabel]);
    const sortProps = react_1.default.useMemo(() => {
        var _a;
        const firstColumn = columns[0];
        return { sortBy: [{ id: (_a = firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.id) !== null && _a !== void 0 ? _a : '', desc: false }] };
    }, [columns]);
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "tabularContent" },
        react_1.default.createElement(styles_1.Table, { columns: tableColumns, data: tableData, striped: true, id: `${provider.id}-${path}`, noResultsMessage: (isFiltered) => isFiltered ? noRecordsOnSearchLabel : noRecordsLabel, paginatorProps: paginatorProps, sortProps: sortProps, stateEventHandlers: stateEventHandlers, ariaProps: {
                ariaLiveLabel: (count) => intl.formatMessage(messages_1.default.ariaLiveSearchResultCount, {
                    count
                })
            } })));
});
//# sourceMappingURL=TabularContent.js.map